import React from 'react';

function Testimonials() {
  return (
    <section className="tc-testimonials-style1">
      <div className="marq-slider">
        <div className="swiper-wrapper">
          <div className="swiper-slide">
            <p> إبداع </p>
          </div>
          <div className="swiper-slide">
            <p> مرونة </p>
          </div>
          <div className="swiper-slide">
            <p> تفان </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
